import { computed, onBeforeMount, useContext, useRoute } from '@nuxtjs/composition-api';
import { selectSizeGuide } from '@shared/composables/useSizeGuide/selectSizeGuide';
import { UseSizeGuideConfig } from '@shared/composables/useSizeGuide/types';
import { ISBSizeGuide } from '@shared/types/ISBSizeGuide';
import {
  getStoriesAsArray,
  getStoryBlokVersion,
  useContent,
} from '@unified-commerce/gpc-vue-storefront-storyblok';

const useSizeGuide = (config?: UseSizeGuideConfig) => {
  const route = useRoute();
  const { $config } = useContext();
  const { slug } = route.value.params;

  const { search, content, loading, error } = useContent(`size-guide-${slug}`);

  onBeforeMount(async () => {
    await search({
      url: '/content/size-guides',
      version: getStoryBlokVersion($config.ENV, route.value),
      relations: 'SizeGuide.brand,SizeGuide.measurement_guide',
      disablePagination: true,
      custom: {
        starts_with: 'content/size-guides',
        filter_query: {
          component: {
            in: 'SizeGuide',
          },
        },
      },
      optimisticStoryLoading: true,
    });
  });

  const sizeGuide = computed<ISBSizeGuide | null>(() =>
    selectSizeGuide(
      getStoriesAsArray(content.value).map((story) => story.content),
      config,
    ),
  );

  return {
    loading,
    error,
    sizeGuide,
  };
};

export default useSizeGuide;
